import React from 'react';

export default function MicIcon({ fill = '#1C274C', stroke = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="40px"
            height="40px"
            viewBox="0 0 392.533 392.533"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <path
                style={{ fill: '#FFFFFF' }}
                d="M196.362,231.887c34.974,0,63.547-28.509,63.547-63.547V85.333c0-34.974-28.509-63.547-63.547-63.547
                c-28.251,0-52.299,18.618-60.444,44.218h38.012c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H132.88
                v19.394h18.23c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925h-18.166v39.434
                C132.815,203.442,161.389,231.887,196.362,231.887z"
            />
            <path
                style={{ fill: '#FFC10D' }}
                d="M196.362,210.101c-22.949,0-41.632-18.683-41.632-41.632V85.333
                c0-22.949,18.683-41.632,41.632-41.632s41.632,18.683,41.632,41.632v83.135C237.995,191.418,219.312,210.101,196.362,210.101z"
            />
            <path
                style={{ fill: '#194F82' }}
                d="M311.95,118.368h-30.255V85.204C281.696,38.206,243.425,0,196.362,0s-85.333,38.271-85.333,85.333
                v33.164H80.71c-6.012,0-10.925,4.848-10.925,10.925v39.046c0,66.069,50.941,120.436,115.588,125.931v36.008
                c-29.608,4.008-53.463,23.984-57.471,49.519l0,0c-1.034,6.659,4.073,12.606,10.731,12.606h115.265
                c6.723,0,11.83-5.947,10.731-12.606c-4.008-25.6-27.927-45.511-57.471-49.519V294.4c64.646-5.56,115.588-59.863,115.588-125.931
                v-39.111C322.876,123.345,317.962,118.368,311.95,118.368z M132.815,128.97h18.166c6.012,0,10.925-4.848,10.925-10.925
                c0,6.012-4.848,10.925-10.925,10.925h-18.166V87.725h41.115c6.012,0,10.925-4.848,10.925-10.925c0,6.012-4.848,10.925-10.925,10.925
                h-38.012c8.21-25.6,32.194-44.218,60.444-44.218c34.974,0,63.547,28.509,63.547,63.547v83.265c0,34.974-28.509,63.547-63.547,63.547
                s-63.547-28.509-63.547-63.547V128.97z M238.059,370.747h-83.394c7.952-11.572,23.79-19.329,41.697-19.329
                S230.108,359.176,238.059,370.747z M301.09,168.469c0,57.729-46.998,104.727-104.727,104.727S91.635,226.133,91.635,168.469v-28.186
                h19.394v28.186c0,47.063,38.271,85.333,85.333,85.333s85.333-38.271,85.333-85.333v-28.186h19.394V168.469z"
            />
            <path
                style={{ fill: '#56ACE0' }}
                d="M154.665,370.747h83.459c-8.016-11.572-23.855-19.329-41.762-19.329S162.617,359.176,154.665,370.747
                z"
            />
        </svg>
    );
}
